import React, {
  useState,
  useEffect,
  useReducer,
  useRef
} from 'react'
import Player from '@vimeo/player';

export const VimeoPlayerEvaluable = props => {

  const [ description, setDescription ] = useState() 
  const playerref = useRef()
  let player
  const sendevent = eventdata => {

    document.dispatchEvent(
      new CustomEvent(
        'playmotiv_contentevaluable',
        {
          detail: {
            blockid: props.attribs.id,
            event: eventdata.event,
            data: eventdata.data
          }
        }
      )
    )
  }

  useEffect(() => {   

    const urlchild = props.children.find(child => child.attribs['data-url'])
    if(urlchild) {

      const url = urlchild.attribs['data-url'] 

      player = new Player(
        playerref.current,
        {
          id: url
        }
      )

      player.on(
        'pause',
        () => {

          player
          .getDuration()
          .then(function(duration) {

            player
            .getCurrentTime()
            .then(function(current) {
              
              sendevent({
                event: 'pause',
                data: {                  
                  status: current / duration
                }
              })
            });  
          });
        }
      )

      player.on(
        'ended',
        () => {
              
          sendevent({
            event: 'ended',
            data: {                  
              status: 1
            }
          })
        }
      )
    }

    const descriptionchild = props.children.find(
      child => child.attribs['class'] && 
               child.attribs['class'] == 'Description'
    )
    if(descriptionchild) {

      setDescription(descriptionchild.children[0].data)
    }
  
  }, [])

  return <div 
    { ...props.attribs }
  >
    <div 
      className="Player" 
      ref={ playerref }
    />
    {
      description &&
      <div 
        className="Description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    }
  </div>
}